var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkBadge, UitkDealGenericBadge } from 'uitk-react-badge';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { getBadgeProps } from '../../../../helpers/badge-helper';
import { iconSizeMapper } from '../../../../business/icon-size';
import { ActivityBadgeTheme } from '../../../../constants';
export var getBadge = function (text, icon, mark, type, theme, styleClasses) {
  var props = getBadgeProps(type, theme, icon, mark, text, styleClasses);
  return React.createElement(UitkBadge, __assign({}, props));
};
export var ImageBadges = function (_a) {
  var badges = _a.badges,
    isVerticalLayout = _a.isVerticalLayout;
  var renderBadge = function () {
    var primary = badges === null || badges === void 0 ? void 0 : badges.primary;
    var secondary = badges === null || badges === void 0 ? void 0 : badges.secondary;
    var primaryIcon = primary === null || primary === void 0 ? void 0 : primary.graphic;
    var primaryMark = primary === null || primary === void 0 ? void 0 : primary.graphic;
    var badgeClasses = "uitk-type-bold uitk-type-200";
    var isCampaignDeal = (primary === null || primary === void 0 ? void 0 : primary.theme) === ActivityBadgeTheme.DEAL_GENERIC;
    var iconSize = (primaryIcon === null || primaryIcon === void 0 ? void 0 : primaryIcon.size) ? iconSizeMapper[primaryIcon.size] : UitkIconSize.EXTRA_SMALL;
    if (isCampaignDeal) {
      return React.createElement(React.Fragment, null, React.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
          top: 'three',
          left: 'three',
          zindex: 'layer2'
        },
        "data-testid": "activity-primary-badge"
      }, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkBadge, {
        className: badgeClasses
      }, primaryIcon && React.createElement(UitkIcon, {
        name: primaryIcon.id,
        size: iconSize
      }))), React.createElement(ViewMedium, null, React.createElement(UitkBadge, {
        text: (primary === null || primary === void 0 ? void 0 : primary.text) || '',
        className: badgeClasses
      }, primaryIcon && React.createElement(UitkIcon, {
        name: primaryIcon.id,
        size: iconSize
      }))))), secondary && React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
          bottom: 'minus-three',
          right: 'three',
          zindex: 'layer2'
        },
        "data-testid": "activity-secondary-badge"
      }, React.createElement(UitkDealGenericBadge, {
        text: (secondary === null || secondary === void 0 ? void 0 : secondary.text) || '',
        className: "".concat(badgeClasses)
      })))));
    }
    var secondaryBadge = function (secondary, isVerticalLayout) {
      var secondaryIcon = secondary === null || secondary === void 0 ? void 0 : secondary.graphic;
      var secondaryMark = secondary === null || secondary === void 0 ? void 0 : secondary.graphic;
      if (secondary && isVerticalLayout) {
        return React.createElement(UitkLayoutPosition, {
          type: "absolute",
          position: {
            bottom: 'minus-three',
            right: 'three',
            zindex: 'layer2'
          },
          "data-testid": "activity-secondary-badge"
        }, getBadge(secondary.text, secondaryIcon, secondaryMark, null, secondary.theme, badgeClasses));
      } else if (secondary) {
        return getBadge(secondary.text, secondaryIcon, secondaryMark, null, secondary.theme, badgeClasses);
      }
      return null;
    };
    return React.createElement(React.Fragment, null, primary && React.createElement(UitkLayoutPosition, {
      type: "absolute",
      position: {
        top: 'three',
        left: 'three',
        zindex: 'layer2'
      },
      "data-testid": "activity-primary-badge"
    }, React.createElement(Viewport, null, React.createElement(ViewSmall, null, getBadge(null, primaryIcon, primaryMark, null, primary.theme, badgeClasses)), React.createElement(ViewMedium, null, getBadge(primary.text, primaryIcon, primaryMark, null, primary.theme, badgeClasses)))), secondaryBadge(secondary, isVerticalLayout));
  };
  return React.createElement(React.Fragment, null, renderBadge());
};